export const generateMockDashboardData = () => ({
  overview: {
    totalProperties: 1247,
    avgPrice: 425000,
    avgProfitMargin: 18.5,
    portfolioValue: 12450000,
    activeWatching: 47,
    recentlyViewed: 156
  },
  marketTrends: [
    { month: 'Jan', avgPrice: 380000, volume: 45, roi: 15.2 },
    { month: 'Feb', avgPrice: 395000, volume: 52, roi: 16.8 },
    { month: 'Mar', avgPrice: 410000, volume: 48, roi: 17.5 },
    { month: 'Apr', avgPrice: 425000, volume: 61, roi: 18.9 },
    { month: 'May', avgPrice: 435000, volume: 58, roi: 19.2 },
    { month: 'Jun', avgPrice: 445000, volume: 64, roi: 18.7 }
  ],
  propertyTypes: [
    { name: 'Single Family', value: 65, count: 812, avgPrice: 445000 },
    { name: 'Townhouse', value: 20, count: 249, avgPrice: 385000 },
    { name: 'Condo', value: 10, count: 125, avgPrice: 295000 },
    { name: 'Multi-Family', value: 5, count: 61, avgPrice: 675000 }
  ],
  locations: [
    { county: 'Camden', properties: 324, avgPrice: 385000, trend: 'up' },
    { county: 'Burlington', properties: 298, avgPrice: 425000, trend: 'up' },
    { county: 'Gloucester', properties: 267, avgPrice: 405000, trend: 'stable' },
    { county: 'Atlantic', properties: 234, avgPrice: 365000, trend: 'down' },
    { county: 'Mercer', properties: 124, avgPrice: 485000, trend: 'up' }
  ],
  recentActivity: [
    { action: 'Added to favorites', property: '123 Main St, Camden NJ', time: '2 hours ago', type: 'favorite' },
    { action: 'Viewed details', property: '456 Oak Ave, Burlington NJ', time: '4 hours ago', type: 'view' },
    { action: 'Added note', property: '789 Pine St, Gloucester NJ', time: '1 day ago', type: 'note' },
    { action: 'Price alert triggered', property: '321 Elm St, Atlantic NJ', time: '2 days ago', type: 'alert' }
  ],
  financialMetrics: {
    totalInvestment: 2450000,
    expectedROI: 18.5,
    riskScore: 65,
    diversificationScore: 78
  }
});

export const generateMockNotes = () => [
  {
    id: 1,
    title: 'Great investment opportunity',
    content: 'This property shows excellent potential for renovation and quick flip. Located in an up-and-coming neighborhood with strong market fundamentals.',
    propertyId: '12345',
    propertyAddress: '123 Main St, Camden NJ',
    tags: ['investment', 'flip', 'renovation'],
    createdAt: '2024-02-15T10:30:00Z',
    updatedAt: '2024-02-15T10:30:00Z'
  },
  {
    id: 2,
    title: 'Market analysis notes',
    content: 'Recent sales in this area showing 15% increase year-over-year. Good time to invest based on market trends and demographic shifts.',
    propertyId: '67890',
    propertyAddress: '456 Oak Ave, Burlington NJ',
    tags: ['market-analysis', 'timing', 'demographics'],
    createdAt: '2024-02-14T15:45:00Z',
    updatedAt: '2024-02-14T15:45:00Z'
  }
];

export const getProgressChartData = {
  marketPerformance: [
    { label: 'Average Price Growth', value: 420000, unit: '' },
    { label: 'Transaction Volume', value: 64, unit: ' deals' },
    { label: 'ROI Performance', value: 19, unit: '%' },
    { label: 'Market Activity', value: 85, unit: '%' },
    { label: 'Price Stability', value: 92, unit: '%' }
  ],
  financialMetrics: (dashboardData) => [
    { label: 'Expected ROI', value: dashboardData?.financialMetrics.expectedROI || 18, unit: '%' },
    { label: 'Risk Management', value: 100 - (dashboardData?.financialMetrics.riskScore || 35), unit: '%' },
    { label: 'Portfolio Diversification', value: dashboardData?.financialMetrics.diversificationScore || 78, unit: '%' },
    { label: 'Market Timing Score', value: 75, unit: '%' },
    { label: 'Location Quality', value: 82, unit: '%' },
    { label: 'Liquidity Rating', value: 68, unit: '%' }
  ],
  locationPerformance: [
    { label: 'Camden County', value: 324, unit: ' properties' },
    { label: 'Burlington County', value: 298, unit: ' properties' },
    { label: 'Gloucester County', value: 267, unit: ' properties' },
    { label: 'Atlantic County', value: 234, unit: ' properties' },
    { label: 'Mercer County', value: 124, unit: ' properties' }
  ]
};

export const getCircularChartData = {
  propertyPortfolio: [
    { label: 'Single Family', value: 812 },
    { label: 'Townhouse', value: 249 },
    { label: 'Condo', value: 125 },
    { label: 'Multi-Family', value: 61 }
  ]
}; 